/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/safety-care",
  shortTitle: "Safety + care",
  title: "Product safety and care",
  category: "Products and care",
  summary: "Material-specific precautions for candles, fragile goods, textiles, fibres, metal, bath accessories and food.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Before first use",
      body: [
        "Read the product-page care and bilingual safety note and any instructions supplied with the goods. Inspect ceramics and glass for cracks or chips, metal for sharp edges, bamboo for split fibres, textiles for damage, and food for an intact seal and current label. Stop and contact customer care if safe use is uncertain.",
      ],
    },
    {
      heading: "Heat, flame and breakage",
      body: [
        "Candle holders require a correctly fitted taper, a level heat-resistant surface and constant adult supervision away from drafts, children, pets and flammable materials. Ceramics, porcelain and glass must not face direct flame or sudden temperature change. Do not continue using a cracked drinking vessel or a chipped glass holder.",
      ],
    },
    {
      heading: "Fibres, finishes and body contact",
      body: [
        "Use a non-slip underlay beneath rugs and keep natural jute dry. Mattress pads are occasional seating layers, not cots or sleeping mattresses. Feather filling may affect sensitive users. Keep bamboo dry and within a reasonable household load. The sisal soap sack should not be used on broken or inflamed skin and its drawstring must be kept from young children.",
        "Zinc-finished and bronzed metalware should not be heated or used as direct food-storage vessels unless a product page expressly confirms food contact. Condensation and wet pot bases can mark surfaces, so use a protective mat and dry promptly.",
      ],
    },
    {
      heading: "Food and incident reporting",
      body: [
        "Delivered food labels control for ingredients, allergens and best-before details. People with milk, soy, gluten or nut concerns must check that pack before eating. Small or hard pieces require age-appropriate supervision.",
        "At the first sign of danger, end use and place the item where nobody else can reach it. Save the object and its packing, then send photographs, purchase details and a factual incident account. Injury or reaction may require suitable professional or emergency assistance. These steps add practical reporting guidance; they do not dilute general product-safety duties or compulsory protections.",
      ],
    },
  ],
};
